module.exports = __webpack_public_path__ + "img/zealy_white.dbf38acb.svg";